import { lazy } from 'react';

export default {
  bookOpen: lazy(() => import('./classic/regular/BookOpen')),
  calendar: lazy(() => import('./classic/regular/Calendar')),
  chartColumn: lazy(() => import('./classic/regular/ChartColumn')),
  cloudArrowDown: lazy(() => import('./classic/regular/CloudArrowDown')),
  eye: lazy(() => import('./classic/regular/Eye')),
  fileLines: lazy(() => import('./classic/regular/FileLines')),
  newspaper: lazy(() => import('./classic/regular/Newspaper')),
  megaphone: lazy(() => import('./classic/regular/Megaphone')),
  suitcase: lazy(() => import('./classic/regular/Suitcase')),
};

